import { render } from "./Footer.vue?vue&type=template&id=5c480971"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5c480971&lang=css"
script.render = render

export default script